import { Spine } from "@esotericsoftware/spine-pixi-v8";
import { sound } from "@pixi/sound";
import { BitmapText, Color, Container, FillGradient, Sprite, Text, TextStyle } from "pixi.js";
import { Group, Tween } from "tweedle.js";
import { currentBackgorundMusic, currentBackgorundMusicVolume, isMusicBtnOnGlobal, languageGlobal, setBackgorundMusic } from "../config/GlobalVariableConfig";
import { getFontConfig } from "../config/introTextConfig";
import { MaxGameWidthHeight } from "../config/reelConfig";
import { Manager } from "../core/Manager";
import { SoundConstants } from "../gameClientEvents/SoundConstants";
import { spinData } from "../server/getServerResposesFun";
import { isFireFox } from "../utils";

declare const window: any;
const translationManager = window.hacksawCasino.Translation;

// Trigger feature names coming from server responses
export type PotType = "doubleReels" | "extraSpin" | "multipliers";

export type FeatureIndicatorColor = "blue" | "green" | "red";


// Positions for feature indicators based on screen orientation and active count
const landscapePositionsMap: Record<number, { x: number, y: number }[]> = {
    1: [{ x: 950, y: 480 }],
    2: [{ x: 750, y: 480 }, { x: 1250, y: 480 }],
    3: [{ x: 960, y: 480 }, { x: 1470, y: 480 }, { x: 450, y: 480 }]
};

const portraitPositionsMap: Record<number, { x: number, y: number }[]> = {
    1: [{ x: 950, y: 480 }],
    2: [{ x: 750, y: 480 }, { x: 1250, y: 480 }],
    3: [{ x: 960, y: 150 }, { x: 1300, y: 690 }, { x: 610, y: 690 }]
};


export class Banner extends Container {

    private bgContainer = new Container();
    private texContainer = new Container(); //-- which needed to scale without any limit

    private backgroundImg: Sprite;

    private bannerText1: Text = new Text({});
    private bannerText2: Text = new Text({});
    private bannerText3: Text = new Text({});
    private bannerText4: Text = new Text({});
    // private bannerText5: Text = new Text({});
    private bannerText5: Text = new Text({});
    private bannerText6: Text = new Text({});
    private continueText: Text = new Text({});
    private transit: Spine | null = null;

    // private backgroundSpine: Spine | null = null;

    private bannerMiddleStatic: Sprite | null = null;

    private winText: BitmapText = new BitmapText({
        text: "",
        style: {
            fontFamily: "3God_coin",
            trim: true,
            fontSize: 120,
            letterSpacing: 5,
        }
    });

    // private leftCharacter: Spine | null = null;
    // private rightCharacter: Spine | null = null;

    private tweenGroup: Group = new Group();

    private screenWidth: number;
    private screenHeight: number;

    private isIntroBannerMode: boolean = true;

    private greenFeatureIndicator: Spine;
    private blueFeatureIndicator: Spine;
    private redFeatureIndicator: Spine;

    private greenFeatureIndicatorType: Spine;
    private blueFeatureIndicatorType: Spine;
    private redFeatureIndicatorType: Spine;

    private greenFeatureIndicatorCont: Container = new Container();
    private blueFeatureIndicatorCont: Container = new Container();
    private redFeatureIndicatorCont: Container = new Container();
    private featureIndicatorContainers: Container[] = [];


    private addedFeatureIndicators: Spine[] = [];       // Stores greenFeatureIndicator, blueFeatureIndicator, redFeatureIndicator
    private addedFeatureIndicatorTypes: Spine[] = [];   // Stores greenFeatureIndicatorType, blueFeatureIndicatorType, redFeatureIndicatorType
    private addedFeatureIndicatorDesc: Text[] = [];     // Stores descriptions (per active feature indicator)

    private greenFeatureIndicatorDesc: Text;
    private blueFeatureIndicatorDesc: Text;
    private redFeatureIndicatorDesc: Text;


    constructor(screenWidth: number, screenHeight: number) {
        super();



        this.screenWidth = screenWidth;
        this.screenHeight = screenHeight;

        this.setupBGImage();

        this.setupBackground();
        this.setupBannerText();

        // this.setupCharacter();

        this.setupFeatureIndicators();

        this.visible = false;

        // this.bgContainer.eventMode = "static"
        this.resize(screenWidth, screenHeight);

    }

    private transition() {

        this.transit = Spine.from({
            skeleton: "bannerTransitionSkel",
            atlas: "bannerTransitionAtlas"
        });

        // this.addChild(this.transit);

        this.setPositionResize(Manager.Orientation || "LANDSCAPE");
    }
    private setupBGImage(): void {
        // this.backgroundImg.label = "backgroundImg";

        this.backgroundImg = Sprite.from("bannerBG");
        this.backgroundImg.alpha = 0;
        this.addChild(this.backgroundImg);


    }
    private setupBackground(): void {


        // this.backgroundSpine = Spine.from({
        //     skeleton: "bannerSkel",
        //     atlas: "bannerAtlas",
        // });


        // this.backgroundSpine.position.set(1920 / 2, 1080 / 2);

        // spineSymbol.scale=0.1;

        // this.backgroundSpine.state.setAnimation(0, "loop", true);

        // this.bgContainer.addChild(this.backgroundSpine);

        // this.bannerMiddleStatic = Spine.from({
        //     skeleton: "bannerPotSkel",
        //     atlas: "bannerPotAtlas"
        // });
        this.bannerMiddleStatic = Sprite.from("bannerOutroStatic");
        this.bannerMiddleStatic.label = "Banner mid static"
        this.bannerMiddleStatic.scale.set(0.9);
        this.bannerMiddleStatic.position.set(600, 100);
        this.bgContainer.addChild(this.bannerMiddleStatic);
        this.addChild(this.bgContainer);

        this.addChild(this.texContainer);

    }

    // private setupCharacter(): void {
    //     this.leftCharacter = Spine.from({
    //         skeleton: "bannerCharLeftSkel",
    //         atlas: "bannerCharLeftAtlas"
    //     })

    //     this.leftCharacter.position.set(100, 400);
    //     this.bgContainer.addChild(this.leftCharacter);

    //     // this.leftCharacter.state.setAnimation(0, "loop", true);


    //     this.rightCharacter = Spine.from({
    //         skeleton: "bannerCharRightSkel",
    //         atlas: "bannerCharRightAtlas"
    //     })
    //     this.rightCharacter.position.set(1800, 200);

    //     this.bgContainer.addChild(this.rightCharacter);

    //     // this.rightCharacter.state.setAnimation(0, "loop", true);


    // }



    private setupFeatureIndicators(): void {
        // ---------------- GREEN FEATURE INDICATOR ----------------
        this.greenFeatureIndicator = Spine.from({
            skeleton: "oceanTriggerIndicatorSkel",
            atlas: "oceanTriggerIndicatorAtlas"
        });
        this.greenFeatureIndicatorType = Spine.from({
            skeleton: "oceanCharacterSkel",
            atlas: "oceanCharacterAtlas"
        });

        // this.greenFeatureIndicator.state.setAnimation(0, "collect", false);
        // this.greenFeatureIndicatorType.state.setAnimation(0, "in", false);

        this.greenFeatureIndicator.position.set(0, -230);
        this.greenFeatureIndicator.scale = 0.9;
        this.greenFeatureIndicatorCont.addChild(this.greenFeatureIndicator);

        this.greenFeatureIndicatorType.position.set(0, 515);
        this.greenFeatureIndicatorType.scale = 0.6;
        this.greenFeatureIndicatorCont.addChild(this.greenFeatureIndicatorType);

        this.greenFeatureIndicatorCont.label = "greenFeatureIndicatorCont";
        // Add description positioned under the indicator
        /* const fill = new FillGradient(0, 0, 0, 32 * 1 * 3);
        const colors = ["#ffffff"].map((color) => Color.shared.setValue(color).toNumber());

        colors.forEach((number, index) => {
            const ratio = index / colors.length;

            fill.addColorStop(ratio, number);
        }); */

        this.greenFeatureIndicatorDesc = new Text({
            text: "",
            style: {
                fontFamily: "Helvetica",
                fontSize: 35,
                fill: "#ffffff",
                wordWrap: true,
                padding: 10,
                wordWrapWidth: 400,
                breakWords: true,
                align: "center",
            }
        });

        this.greenFeatureIndicatorDesc.text = translationManager.game('banner_intro_desc_2_option3');
        this.greenFeatureIndicatorDesc.anchor.set(0.5);
        this.greenFeatureIndicatorDesc.position.set(0, 0);
        this.greenFeatureIndicatorCont.addChild(this.greenFeatureIndicatorDesc);

        // ---------------- BLUE FEATURE INDICATOR ----------------
        this.blueFeatureIndicator = Spine.from({
            skeleton: "lightTriggerIndicatorSkel",
            atlas: "lightTriggerIndicatorAtlas"
        });
        this.blueFeatureIndicatorType = Spine.from({
            skeleton: "lightCharacterSkel",
            atlas: "lightCharacterAtlas"
        });

        this.blueFeatureIndicator.position.set(0, -230);
        this.blueFeatureIndicator.scale = 0.9;
        this.blueFeatureIndicatorCont.addChild(this.blueFeatureIndicator);

        this.blueFeatureIndicatorType.position.set(0, 515);
        this.blueFeatureIndicatorType.scale = 0.65;
        this.blueFeatureIndicatorCont.addChild(this.blueFeatureIndicatorType);

        this.blueFeatureIndicatorCont.label = "blueFeatureIndicatorCont";

        this.blueFeatureIndicatorDesc = new Text({
            text: "",
            style: {
                fontFamily: "Helvetica",
                fill: "#ffffff",
                fontSize: 35,
                padding: 10,
                wordWrap: true,
                wordWrapWidth: 400,
                breakWords: true,
                align: "center",
            }
        });
        this.blueFeatureIndicatorDesc.text = translationManager.game('banner_intro_desc_2_option1');
        this.blueFeatureIndicatorDesc.anchor.set(0.5);
        this.blueFeatureIndicatorDesc.position.set(0, 0);
        this.blueFeatureIndicatorCont.addChild(this.blueFeatureIndicatorDesc);


        // ---------------- RED FEATURE INDICATOR ----------------
        this.redFeatureIndicator = Spine.from({
            skeleton: "infernoTriggerIndicatorSkel",
            atlas: "infernoTriggerIndicatorAtlas"
        });
        this.redFeatureIndicatorType = Spine.from({
            skeleton: "infernCharacterSkel",
            atlas: "infernCharacterAtlas"
        });


        this.redFeatureIndicator.position.set(0, -230);
        this.redFeatureIndicator.scale = 0.9;
        this.redFeatureIndicatorCont.addChild(this.redFeatureIndicator);

        this.redFeatureIndicatorType.position.set(0, 515);
        this.redFeatureIndicatorType.scale = 0.65;
        this.redFeatureIndicatorCont.addChild(this.redFeatureIndicatorType);

        this.redFeatureIndicatorCont.label = "redFeatureIndicatorCont";
        // this.redFeatureIndicatorDesc = new Text("", this.bannerText3.style);

        this.redFeatureIndicatorDesc = new Text({
            text: "",
            style: {
                fontFamily: "Helvetica",
                fill: "#ffffff",
                fontSize: 35,
                padding: 10,
                wordWrap: true,
                wordWrapWidth: 400,
                breakWords: true,
                align: "center",
            }
        });
        this.redFeatureIndicatorDesc.text = translationManager.game('banner_intro_desc_2_option2');
        this.redFeatureIndicatorDesc.anchor.set(0.5);
        this.redFeatureIndicatorDesc.position.set(0, 0);
        this.redFeatureIndicatorCont.addChild(this.redFeatureIndicatorDesc);
    }

    private resetFeatureIndicatorContainers(): void {
        this.bgContainer.removeChild(this.greenFeatureIndicatorCont);
        this.bgContainer.removeChild(this.blueFeatureIndicatorCont);
        this.bgContainer.removeChild(this.redFeatureIndicatorCont);

        this.addedFeatureIndicators = [];
        this.addedFeatureIndicatorTypes = [];
        this.addedFeatureIndicatorDesc = [];

        this.featureIndicatorContainers = [];
    }

    private getCurrentPositionsMap(): Record<number, { x: number, y: number }[]> {
        return (this.screenWidth > this.screenHeight) ? landscapePositionsMap : portraitPositionsMap;
    }

    private addFeatureIndicators(indicatorColors: FeatureIndicatorColor[]): void {

        // Clear previous additions

        this.resetFeatureIndicatorContainers();

        // Define positions based on number of active features
        const positions = this.getCurrentPositionsMap()[indicatorColors.length];

        indicatorColors.forEach((indicatorColor, index) => {
            let indicator!: Spine;
            let indicatorType!: Spine;
            let container!: Container;
            let descText!: Text;
            switch (indicatorColor) {
                case "green":
                    indicator = this.greenFeatureIndicator;
                    indicatorType = this.greenFeatureIndicatorType;
                    container = this.greenFeatureIndicatorCont;
                    descText = this.greenFeatureIndicatorDesc;
                    break;
                case "blue":
                    indicator = this.blueFeatureIndicator;
                    indicatorType = this.blueFeatureIndicatorType;
                    container = this.blueFeatureIndicatorCont;
                    descText = this.blueFeatureIndicatorDesc;
                    break;
                case "red":
                    indicator = this.redFeatureIndicator;
                    indicatorType = this.redFeatureIndicatorType;
                    container = this.redFeatureIndicatorCont;
                    descText = this.redFeatureIndicatorDesc;
                    break;
                default: {
                    const _exhaustive: never = indicatorColor;
                    throw new Error(`Unhandled feature indicator color: ${_exhaustive}`);
                }
            }

            container.position.set(positions[index].x, positions[index].y);
            this.bgContainer.addChild(container);

            this.addedFeatureIndicators.push(indicator);
            this.addedFeatureIndicatorTypes.push(indicatorType);
            this.addedFeatureIndicatorDesc.push(descText);
            this.featureIndicatorContainers.push(container);
        });
    }

    private setupBannerText(): void {

        const {
            fontFamily: fontFamilyHeading,
            fontWeight: fontWeightHeading,
            fontSize: fontSizeHeading,
        } = getFontConfig(languageGlobal, "introHeading");



        const fill = new FillGradient(0, 0, 0, 32 * 1 * 3);
        const colors = ["#ffffff"].map((color) => Color.shared.setValue(color).toNumber());

        colors.forEach((number, index) => {
            const ratio = index / colors.length;

            fill.addColorStop(ratio, number);
        });

        this.bannerText1.style = new TextStyle({
            fontFamily: fontFamilyHeading,
            fill: isFireFox() ? "#ffffff" : { fill },
            fontWeight: fontWeightHeading,
            fontSize: fontSizeHeading,
            stroke: {
                color: "#25a7f8",
                width: 3,
            },
            dropShadow: isFireFox() ? false :
                {
                    blur: 5,
                    color: "#000000",
                    distance: 6,
                },
            letterSpacing: 1,
            align: "center",
            // breakWords: true,
            // wordWrap: true,
            // wordWrapWidth: 850,

        });



        const {
            fontFamily: fontFamilyDesc1,
            fontWeight: fontWeightDesc1,
            fontSize: fontSizeDesc1,
            // lineHeight: lineHeightDesc1
        } = getFontConfig(languageGlobal, "introDesc1");

        this.bannerText2.style = new TextStyle({
            fontFamily: fontFamilyDesc1,
            fill: isFireFox() ? "#ffffff" : { fill },
            fontWeight: fontWeightDesc1,
            fontSize: fontSizeDesc1,
            stroke: {
                color: "#744303",
                width: 3,
            },
            dropShadow: isFireFox() ? false :
                {
                    blur: 5,
                    color: "#000000",
                    distance: 6,
                },
            align: "center",
            // trim: true,
            letterSpacing: 1,
            // fontVariant: "small-caps",
            //breakWords: true,
            wordWrap: true,
            wordWrapWidth: 1200,
            //lineHeight: lineHeightDesc1,
        });

        this.bannerText5.style = new TextStyle({
            fontFamily: fontFamilyHeading,
            fill: { fill },
            fontWeight: fontWeightHeading,
            fontSize: fontSizeHeading,
            stroke: {
                color: "#744303",
                width: 3,
            },
            dropShadow:
            {
                blur: 5,
                color: "#000000",
                distance: 6,
            },
            letterSpacing: 1,
            align: "center",
            // breakWords: true,
            // wordWrap: true,
            // wordWrapWidth: 850,

        });


        this.bannerText6.style = new TextStyle({
            fontFamily: fontFamilyDesc1,
            fill: { fill },
            fontWeight: fontWeightDesc1,
            fontSize: 70,
            stroke: {
                color: "#744303",
                width: 3,
            },
            dropShadow:
            {
                blur: 5,
                color: "#000000",
                distance: 6,
            },
            align: "center",
            // trim: true,
            letterSpacing: 1,
            // fontVariant: "small-caps",
            //breakWords: true,
            wordWrap: true,
            wordWrapWidth: 1000,
            //lineHeight: lineHeightDesc1,
        });


        const {
            fontFamily: fontFamilyDesc2,
            fontWeight: fontWeightDesc2,
            fontSize: fontSizeDesc2,
            lineHeight: lineHeightDesc2
        } = getFontConfig(languageGlobal, "introDesc2");

        const desc2TextStyle = new TextStyle({
            fontFamily: fontFamilyDesc2,
            fill: "#ffffff",
            fontWeight: fontWeightDesc2,
            fontSize: fontSizeDesc2,
            align: "center",
            wordWrap: true,
            // trim: true,
            letterSpacing: 1,
            wordWrapWidth: 950,
            lineHeight: lineHeightDesc2,
            breakWords: true,
        });

        this.bannerText3.style = desc2TextStyle;
        this.bannerText4.style = desc2TextStyle;
        // this.bannerText5.style = desc2TextStyle;


        const {
            fontFamily: fontFamilyContinue,
            fontWeight: fontWeightContinue,
            fontSize: fontSizeContinue2,
        } = getFontConfig(languageGlobal, "introContinue");

        const continueTextStyle = new TextStyle({
            fontFamily: fontFamilyContinue,
            fill: "#ffffff",
            fontWeight: fontWeightContinue,
            fontSize: fontSizeContinue2,
            stroke: languageGlobal === "th-th" ? undefined : {
                color: "#744303",
                width: 3,
            },
            dropShadow: isFireFox() ? false :
                languageGlobal === "th-th" ? undefined : {
                    blur: 5,
                    color: "#000000",
                    distance: 6,
                },
        });

        this.continueText.text = translationManager.game('intro_continue_uc')
        this.continueText.style = continueTextStyle


        this.bannerText1.anchor.set(0.5);
        this.bannerText2.anchor.set(0.5);
        this.bannerText3.anchor.set(0.5);
        this.bannerText4.anchor.set(0.5);
        this.bannerText5.anchor.set(0.5);
        this.bannerText6.anchor.set(0.5);
        this.continueText.anchor.set(0.5);
        this.winText.anchor.set(0.5);

        // const spacing = 20;
        this.texContainer.addChild(this.bannerText1);
        this.texContainer.addChild(this.bannerText2);
        this.texContainer.addChild(this.bannerText3);
        this.texContainer.addChild(this.bannerText4);
        this.texContainer.addChild(this.bannerText5);
        this.texContainer.addChild(this.bannerText6);
        this.texContainer.addChild(this.continueText);
        this.texContainer.addChild(this.winText);

        this.prepareContinueHidden();
    }

    private prepareContinueHidden(): void {
        this.tweenGroup.removeAll();
        this.continueText.visible = false;
        this.continueText.alpha = 0;
        this.continueText.scale.set(1, 1);
        this.continueText.eventMode = "none";
        this.eventMode = "none";
    }

    private fadeInTexContainerForBanner(toFreeGame: boolean): Promise<void> {
        return new Promise<void>((resolve) => {

            let textScale;
            if (this.screenWidth > this.screenHeight) {
                textScale = Math.min(this.screenWidth / 1920, this.screenHeight / 1080);
            }
            else {
                textScale = Math.min(this.screenWidth / 1080, this.screenHeight / 1920);
            }

            this.texContainer.alpha = 0;
            this.texContainer.scale = textScale;

            const tweenAlpha = new Tween(this.texContainer, this.tweenGroup)
                .to({ alpha: 1 }, 500)
                .onStart(() => {
                    this.switchTheBackgroundMusic(toFreeGame);
                })
                .onComplete(() => {
                    this.tweenGroup.remove(tweenAlpha);
                    resolve();
                })
                .start();
        });
    }

    /** Shows continue, plays pop + idle pulse, then enables pointer hits on this banner. */
    private revealContinueAndEnableInput(): Promise<void> {
        return new Promise<void>((resolvePop) => {
            this.continueText.visible = true;
            this.continueText.alpha = 0;
            this.continueText.scale.set(0, 0);

            const popTween = new Tween(
                { scale: 0, alpha: 0 },
                this.tweenGroup
            )
                .to({ scale: 1.2, alpha: 1 }, 200)
                .onUpdate((obj) => {
                    this.continueText.scale.set(obj.scale, obj.scale);
                    this.continueText.alpha = obj.alpha;
                })
                .chain(
                    new Tween({ scale: 1.2 }, this.tweenGroup)
                        .to({ scale: 1.0 }, 150)
                        .onUpdate((obj) => {
                            this.continueText.scale.set(obj.scale, obj.scale);
                        })
                        .onComplete(() => {
                            new Tween(this.continueText.scale, this.tweenGroup)
                                .to({ x: 1.03, y: 1.03 }, 1000)
                                .yoyo(true)
                                .repeat(Infinity)
                                .start();

                            this.tweenGroup.remove(popTween);
                            this.eventMode = "static";
                            resolvePop();
                        })
                )
                .start();
        });
    }

    public async appearFreeGameIntroBanner(freeGameNumber: number, indicatorColors: FeatureIndicatorColor[]) {

        return new Promise<void>(async (resolve) => {
            this.isIntroBannerMode = true;
            this.prepareContinueHidden();
            this.resize(this.screenWidth, this.screenHeight);
            const triggeredFeature = spinData.triggerFeatures;

            this.visible = true;
            this.bgContainer.alpha = 0;
            this.bgContainer.visible = false;
            this.transition();
            const transitComplete = new Promise<void>((resolveTransit) => {
                // if (!this.transit) {
                //     resolveTransit();
                //     return;
                // }
                const entry = this.transit.state.setAnimation(0, "transition", false);
                entry.listener = {
                    event: (entry, event) => {
                        if (event.data.name === "change") {
                            console.log("Event trigger", entry);
                            if (this.bgContainer) {
                                this.bgContainer.alpha = 1;
                                this.bgContainer.visible = true;
                            }
                        }
                    },
                    complete: () => {
                        this.transit?.state.clearListeners();
                        resolveTransit();
                    }
                };
            });
            this.addFeatureIndicators(indicatorColors);

            this.bannerText1.visible = true;
            this.bannerText2.visible = false;
            this.bannerText3.visible = false;
            this.bannerText4.visible = false;
            this.bannerText5.visible = false;
            this.bannerText6.visible = false;

            this.winText.visible = false;

            this.bannerText1.scale = 1;
            // this.bannerText1.text = translationManager.game('banner_intro_heading_uc');// '8-BIT BONUS';
            this.bannerText1.text = translationManager.game(triggeredFeature.length > 1 ? 'banner_intro_heading_uc_option2' : 'banner_intro_heading_uc_option1');
            this.bannerText1.scale = Math.min(1, 900 / this.bannerText1.width);
            // this.bannerText1.y = -480;

            // this.bannerText2.scale = 1;

            // this.bannerText2.text = translationManager.game('banner_intro_desc_option1', null, { 'freegamenumber': freeGameNumber });//`You won ${freeGameNumber} Free Spins!`
            // this.bannerText2.text = translationManager.game(triggeredFeature.length > 1 ? 'banner_intro_desc_option2' : 'banner_intro_desc_option1');
            // this.bannerText2.y = -400;
            console.log(freeGameNumber, "freeGameNumber");  //only to avoid too many changes, just calling it in logs
            // this.bannerText2.scale = Math.min(1, 850 / this.bannerText2.width);

            this.bannerText3.text = translationManager.game('banner_intro_desc_2');//'During the bonus game, the multiplier accumulates with each win that involves a wild symbol with a multiplier.';
            // this.bannerText3.y = -55;
            // this.bannerText3.scale = Math.min(1, (this.bannerBackground.width - 150) / this.bannerText3.width);

            this.bannerText4.text = translationManager.game('banner_intro_desc_3');//'The multiplier persists throughout the entire duration of the bonus game.';
            // this.bannerText4.y = 110;

            // this.bannerText5.text = translationManager.game('banner_intro_desc_4');//'The multiplier persists throughout the entire duration of the bonus game.';
            // this.bannerText5.y = 250;

            // this.continueText.y = 500;

            this.visible = true;




            this.bannerMiddleStatic.visible = false;
            // this.backgroundBlackLayer.visible = false;

            // sound.play('free_Game_Banner', { volume: 0.5 });

            // this.backgroundSpine.state.setAnimation(0, "in", false).listener = {
            //     complete: async () => {
            //         this.backgroundSpine.state.setAnimation(0, "loop", true);

            //         await this.appearText(true);
            //         resolve();

            //         this.backgroundSpine.state.clearListeners();
            //     }
            // };


            await new Promise<void>((resolve) => {
                const tween = new Tween(this.backgroundImg, this.tweenGroup)
                    .to({ alpha: 1 }, 200)
                    .onStart(() => {
                        sound.play('free_Game_Banner', { volume: 1 });
                    })
                    .onComplete(() => {
                        this.tweenGroup.remove(tween);
                        resolve();
                    })
                    .start();
            })



            const promises: Promise<void>[] = [];

            // const playInAnimation = (characterSpine: Spine) => {
            //     return new Promise<void>((resolveCharacter) => {
            //         characterSpine.state.setAnimation(0, "in", false).listener = {
            //             complete: () => {
            //                 characterSpine.state.setAnimation(0, "loop", true);
            //                 characterSpine.state.clearListeners();
            //                 resolveCharacter();
            //             }
            //         };
            //     });
            // };

            this.addedFeatureIndicators.forEach((indicator) => {
                promises.push(this.playSpineAnimation(indicator, "collect", "loop"));
            })

            this.addedFeatureIndicatorTypes.forEach((indicatorType) => {
                promises.push(this.playSpineAnimation(indicatorType, "in", "idle"));
            })


            Promise.all(promises).then(async () => {
                await Promise.all([
                    this.fadeInTexContainerForBanner(true),
                    transitComplete,
                ]);
                await this.revealContinueAndEnableInput();
                resolve();
            });

        })


    }

    private playSpineAnimation(spine: Spine, animationName: string, loopAfter?: string): Promise<void> {
        return new Promise<void>((resolve) => {
            spine.state.setAnimation(0, animationName, false).listener = {
                complete: () => {
                    spine.state.clearListeners();
                    if (loopAfter) {
                        spine.state.setAnimation(0, loopAfter, true);
                    }
                    resolve();
                }
            };
        });
    }



    private switchTheBackgroundMusic(toFreeGame: boolean) {

        let targetMusicLoop;
        if (toFreeGame) {
            targetMusicLoop = sound.find('free_background_loop');
        }
        else {
            targetMusicLoop = sound.find('base_music_loop');
        }

        let currentVal: number = currentBackgorundMusicVolume;
        let targetVal: number = 0;

        const tween = new Tween({ x: currentVal }, this.tweenGroup)
            .to({ x: targetVal }, 750)
            .onUpdate((object) => {
                currentBackgorundMusic.volume = object.x;
                // console.log("this.backGroundMusic", this.backGroundMusic.volume);
            })
            .onComplete(() => {
                this.tweenGroup.remove(tween);
                playFgMusic();

            })
            .start();


        const playFgMusic = () => {
            let currentVal: number = .10;
            let targetVal: number = currentBackgorundMusicVolume;

            // initialize with ambient sound
            setBackgorundMusic(targetMusicLoop);

            const tween = new Tween({ x: currentVal }, this.tweenGroup)
                .to({ x: targetVal }, 750)
                .onStart(() => {
                    currentBackgorundMusic.loop = true;
                    currentBackgorundMusic.singleInstance = true;
                    currentBackgorundMusic.play();
                    currentBackgorundMusic.muted = !isMusicBtnOnGlobal;
                })
                .onUpdate((object) => {
                    currentBackgorundMusic.volume = object.x;

                    // console.log("this.backGroundMusic", this.backGroundMusic.volume);
                })
                .onComplete(() => {
                    this.tweenGroup.remove(tween);
                })
                .start();
        }
    }



    public async disappearBanner(): Promise<void> {
        return new Promise<void>(async (resolve) => {

            this.prepareContinueHidden();
            // this.texContainer.alpha = 0;
            // this.texContainer.scale = 0;

            await new Promise<void>((resolve) => {
                const tween = new Tween(this.backgroundImg, this.tweenGroup)
                    .to({ alpha: 1 }, 200)
                    .onComplete(() => {
                        this.tweenGroup.remove(tween);
                        resolve()
                    })
                    .start();
            })

            if (!this.isIntroBannerMode && this.bannerMiddleStatic) {
                new Promise<void>(() => {
                    this.bannerMiddleStatic.visible = true;
                });
            }
            const promises: Promise<void>[] = [];

            this.addedFeatureIndicatorTypes.forEach((indicatorType) => {
                promises.push(this.playSpineAnimation(indicatorType, "out"));
            })

            this.transition();
            sound.play(SoundConstants.INTRO_TRANSITION, { volume: 0.7 });
            const entry = this.transit.state.setAnimation(0, "transition", false);
                entry.listener = {
                event: (entry, event) => {
                    if (event.data.name === "change") {
                        this.backgroundImg.alpha = 0;
                        this.bgContainer.alpha = 0;
                        this.texContainer.alpha = 0;
                        this.texContainer.scale = 0;
                        console.log("Event trigger", entry);
                    }
                },
                complete: async () => {
                    await Promise.all(promises);
                    this.visible = false;
                    this.eventMode = "none";
                    resolve();
                }
            };

            // Promise.all(promises).then(() => {
            //     resolve();
            // });
        });
    }

    public setPositionResize(orientation: string): void {
        const BG_SCALE_FACTOR = Math.max(Manager.screenwidth / 2048, Manager.screenHeight / 2048);
        let scale;
        let bgScale;
        if (orientation === "LANDSCAPE") {
            scale = 1 * Math.min(Manager.screenwidth / 1920, Manager.screenHeight / 2048);
        } else {
            scale = 1.0 * Math.min(Manager.screenwidth / 1080, Manager.screenHeight / 2048);
        }
        bgScale = Math.max(scale, BG_SCALE_FACTOR);

        if (this.transit) {
            this.transit.scale.set(bgScale, bgScale)
            const bgXPos = Manager.screenwidth / 2;
            const bgYPos = Manager.screenHeight / 2;
            this.transit.position.set(bgXPos, bgYPos);
        }
    }
    public async appearFreeGameOutroBanner(
        totalWin: number,
        freeSpins: number,
        onOutroTransitionChange?: () => void | Promise<void>,
    ) {

        return new Promise<void>(async (resolve) => {
            this.isIntroBannerMode = false;
            this.prepareContinueHidden();
            this.resize(this.screenWidth, this.screenHeight);

            let resolveOutroTransitionChange: (() => void) | null = null;
            const whenOutroTransitionChange = new Promise<void>((r) => {
                resolveOutroTransitionChange = r;
            });


            this.visible = true;
            this.bgContainer.alpha = 0;
            this.bgContainer.visible = false;
            this.texContainer.visible = false;
            this.backgroundImg.visible = false;
            this.transition();
            const transitComplete = new Promise<void>((resolveTransit) => {
                if (!this.transit) {
                    resolveTransit();
                    return;
                }
                sound.play(SoundConstants.INTRO_TRANSITION, { volume: 0.7 });
                const entry = this.transit.state.setAnimation(0, "transition", false);
                entry.listener = {
                    event: (entry, event) => {
                        if (event.data.name === "change") {
                            console.log("Event trigger", entry);
                            if (this.bgContainer) {
                                this.bgContainer.alpha = 1;
                                this.bgContainer.visible = true;
                                this.texContainer.visible = true;
                                this.backgroundImg.visible = true;
                            }
                            resolveOutroTransitionChange?.();
                            resolveOutroTransitionChange = null;
                        }
                    },
                    complete: () => {
                        this.transit?.state.clearListeners();
                        resolveTransit();
                    }
                };
            });
            this.resetFeatureIndicatorContainers();
            this.bannerText1.visible = false;
            this.bannerText2.visible = false;
            this.bannerText3.visible = false;

            this.bannerText5.visible = true;
            this.bannerText6.visible = true;
            // this.bannerText5.visible = false;

            this.winText.visible = true;

            this.bannerText5.scale = 1;
            this.bannerText5.text = translationManager.game('banner_outro_heading_uc');// '8-BIT BONUS';
            this.bannerText5.scale = Math.min(1, 900 / this.bannerText5.width);
            this.bannerText5.y = -400;

            // this.bannerText2.scale = 1;

            this.bannerText6.text = translationManager.game('banner_outro_desc_1', null, { 'winnumber': freeSpins });
            // this.bannerText2.y = -120;
            // this.bannerText2.scale = Math.min(1, 850 / this.bannerText2.width);


            this.winText.scale = 1;
            this.winText.text = totalWin.toFixed(2);
            this.winText.scale = Math.min(1, 900 / this.winText.width);
            this.winText.y = -150;

            // this.continueText.y = 400;


            this.texContainer.alpha = 0;
            this.texContainer.scale = 0;

            // this.backgroundBlackLayer.visible = true;
            // this.backgroundBlackLayer.scale = 10;
            // this.backgroundBlackLayer.alpha = 0.6;
            this.bannerMiddleStatic.visible = true;

            await whenOutroTransitionChange;
            if (onOutroTransitionChange) {
                await onOutroTransitionChange();
            }

            await new Promise<void>((r) => {
                const tween = new Tween(this.backgroundImg, this.tweenGroup)
                    .to({ alpha: 1 }, 200)
                    .onStart(() => {
                        sound.play(SoundConstants.TOTAL_WIN, { volume: 0.5 });
                    })
                    .onComplete(() => {
                        this.tweenGroup.remove(tween);
                        sound.play(SoundConstants.TOTAL_WIN_END, { volume: 0.5 });
                        r();
                    })
                    .start();
            });

            await Promise.all([
                this.fadeInTexContainerForBanner(false),
                transitComplete,
            ]);
            await this.revealContinueAndEnableInput();
            resolve();

        })

    }


    public resize(screenWidth: number, screenHeight: number): void {

        this.screenWidth = screenWidth;
        this.screenHeight = screenHeight;

        let scale: number;

        let bgScale;
        const BG_SCALE_FACTOR = Math.max(screenWidth / MaxGameWidthHeight, screenHeight / MaxGameWidthHeight);


        if (screenWidth > screenHeight) {
            scale = Math.min(screenWidth / 1920, screenHeight / 1080);
            bgScale = Math.max(scale, BG_SCALE_FACTOR);

            this.texContainer.scale.set(scale, scale);

            const xPos = (MaxGameWidthHeight * bgScale - screenWidth) / 2;
            const yPos = (MaxGameWidthHeight * bgScale - screenHeight) / 2;

            this.backgroundImg.scale = bgScale;
            this.backgroundImg.x = -xPos;
            this.backgroundImg.y = -yPos;

            // this.backgroundBlackLayer.x = -xPos;
            // this.backgroundBlackLayer.y = -yPos;

            this.bgContainer.scale.set(scale, scale)
            const bgXPos = (1920 * scale - screenWidth) / 2;
            const bgYPos = (1080 * scale - screenHeight) / 2;
            this.bgContainer.position.set(-bgXPos, -bgYPos);

            if (this.isIntroBannerMode) {
                this.bannerText1.y = -480;
                this.bannerText2.y = -400;
                this.bannerText3.y = -55;
                this.bannerText4.y = 110;
                this.continueText.y = 500;

                this.bannerText1.style.fontSize = 90;
                this.bannerText2.style.fontSize = 60;
                this.continueText.style.fontSize = 55;
            } else {
                this.bannerText5.y = -455;
                this.bannerText6.y = -362;
                this.winText.y = 212;
                this.continueText.y = 410;
                this.bannerMiddleStatic.scale.set(0.9);
                this.bannerMiddleStatic.position.set(600, 190);
            }


            const positions = landscapePositionsMap[this.featureIndicatorContainers.length];
            this.featureIndicatorContainers.forEach((container, index) => {
                container.position.set(positions[index].x, positions[index].y);
            })
            // this.leftCharacter.position.set(200, 500);
            // this.rightCharacter.position.set(1800, 500);

        }
        else {
            scale = Math.min(screenWidth / 1080, screenHeight / 1920);
            bgScale = Math.max(scale, BG_SCALE_FACTOR);


            this.texContainer.scale.set(scale, scale);

            const xPos = (MaxGameWidthHeight * bgScale - screenWidth) / 2;
            const yPos = (MaxGameWidthHeight * bgScale - screenHeight) / 2;

            this.backgroundImg.scale = bgScale;
            this.backgroundImg.x = -xPos;
            this.backgroundImg.y = -yPos;


            this.bgContainer.scale.set(scale, scale)
            const bgXPos = (1920 * scale - screenWidth) / 2;
            const bgYPos = (1080 * scale - screenHeight) / 2;
            this.bgContainer.position.set(-bgXPos, -bgYPos);

            // this.leftCharacter.position.set(500, 500);
            // this.rightCharacter.position.set(1450, 500);

            if (this.isIntroBannerMode) {
                this.bannerText1.y = -725;
                this.bannerText2.y = -540;
                this.bannerText3.y = -55;
                this.bannerText4.y = 110;
                this.continueText.y = 850;

                this.bannerText1.style.fontSize = 95;
                this.bannerText2.style.fontSize = 60;
                this.continueText.style.fontSize = 62;
            } else {
                this.bannerText5.y = -585;
                this.bannerText6.y = -460;
                this.winText.y = 250;
                this.continueText.y = 508;
                this.bannerMiddleStatic.scale.set(1);
                this.bannerMiddleStatic.position.set(560, 100);
            }

            const positions = portraitPositionsMap[this.featureIndicatorContainers.length];
            this.featureIndicatorContainers.forEach((container, index) => {
                container.position.set(positions[index].x, positions[index].y);
            })

        }

        this.texContainer.position.set(screenWidth / 2, screenHeight / 2);

    }

    public update(): void {
        // Update the tween group
        this.tweenGroup.update();

    }
}